import React, { createContext } from "react";
import { User, onAuthStateChanged } from "firebase/auth";


// Create the AuthContext with a default value of null
export const AuthContext = createContext<User | null>(null);

